export default __webpack_public_path__ + "static/media/Leg of Fena.bf9b5498.jpg";